<template>
  <div class="p-page-wrapper">
    <template v-if="!currentProjectId">
      <v-row>
        <v-col>
          <p-no-data
            :text="$t('noProjects')"
            :hide-btn="true"
            img="chat.png"
            class="p-no-data-mt"
          ></p-no-data>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <p-routed-tabs
        :tabs="tabs"
        class="pt-1"
      ></p-routed-tabs>
      <router-view/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PRoutedTabs from '@/components/PRoutedTabs'
import PNoData from '@/components/PNoData'

import pageMixin from '@/mixins/page.mixin'


export default {
  components: {
    PRoutedTabs,
    PNoData
  },


  mixins: [
    pageMixin
  ],


  data () {
    return {
      tabs: [
        { title: this.$t('communication.tabs.emails'), route: 'communicationEmails' },
        { title: this.$t('communication.tabs.sms'), route: 'communicationSms' }
      ]
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId'])
  },


  methods: {
    ...mapActions('contact', ['loadShortContacts', 'loadPhoneContactsMobile'])
  },

  async created () {
    this.setPageTitle(this.$t('nav.communication'))
    if (!this.currentProjectId) return false
    try {
      await this.loadShortContacts()
      await this.loadPhoneContactsMobile()
    } catch (error) {
      this.$log.error(error)
    }
  }
}
</script>
